module.exports = __webpack_public_path__ + "img/clay-banks-LjqARJaJotc-unsplash.9ad246ef.jpg";